export default __webpack_public_path__ + "static/media/Cardwaterpool.8be4dbfd.jpg";